import { Routes } from "@angular/router";
import { AdminGuard } from "../guard/admin.guard";
import { UserProfileComponent } from "../../components/profile/user-profile/user-profile.component";
import { CollectionsListComponent } from "../../components/collections-report/collections-list/collections-list.component";

export const content: Routes = [
  // {
  //   path: "events",
  //   loadChildren: () => import("../../components/events/events.routes"),
  //   canActivate: [AdminGuard],
  //   data: {
  //     title: "routes.events",
  //   }
  // },
  // {
  //   path: "stores",
  //   loadChildren: () => import("../../components/stores/stores.routes"),
  //   canActivate: [AdminGuard],
  //   data: {
  //     title: "routes.stores",
  //     roles: ["admin", "store_manager", "kam"],
  //   }
  // },
  // {
  //   path: "check-in",
  //   loadChildren: () => import("../../components/check-in/check-in.routes"),
  //   canActivate: [AdminGuard],
  //   data: {
  //     title: "routes.check-in",
  //     roles: ["admin", "store_manager", "kam"],
  //   },
  // },
  // {
  //   path: "profile",
  //   canActivate: [AdminGuard],
  //   component: UserProfileComponent,
  //   data: {
  //     title: "routes.profile",
  //     roles: ["admin", "store_manager", "kam"],
  //   },
  // },
  {
    path: "profile",
    canActivate: [AdminGuard],
    component: UserProfileComponent,
    data: {
      title: "routes.profile",
      roles: ["admin", "store_manager"],
    },
  },
  {
    path: "customers",
    loadChildren: () => import("../../components/collections/collections.routes"),
    canActivate: [AdminGuard],
    data: {
      title: "routes.collections",
      roles: ["admin", "store_manager"],
    },
  },
  {
    path: "report",
    component: CollectionsListComponent,
    canActivate: [AdminGuard],
    data: {
      title: "routes.report",
      roles: ["admin", "store_manager"],
    },
  },
];
